import React from 'react';
import { useRecoilValue } from 'recoil';
import { isMobileState } from '../../recoil/selectors';
import { ModalToggleState } from '../../models/actionStates';
import { useSetModalState } from './useModalState';
import { SupportModal } from '../../support/SupportModal';

export const useSupportModal = (): (() => void) => {
  const isMobile = useRecoilValue(isMobileState);
  const setModal = useSetModalState();
  const modalHeightWidth = isMobile ? '100%' : '900px';
  return () => {
    setModal({
      contents: <SupportModal />,
      height: isMobile ? '100vh' : 'auto',
      width: modalHeightWidth,
      maxWidth: '100vw',
      maxHeight: 'unset',
      toggleState: ModalToggleState.Open,
      scrollToTop: false,
      isBaseState: false,
    });
  };
};
